'use strict';

import React from 'react';
import { Modal, Alert } from 'react-bootstrap';
import Cookies from 'js-cookie'
import InputFieldComponent from './InputFieldComponent.js'

require('styles//ContactForm.css');

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

class ContactFormComponent extends React.Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.closeAndSubmit = this.closeAndSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSuccessDismiss = this.handleSuccessDismiss.bind(this);
    this.handleErrorDismiss = this.handleErrorDismiss.bind(this);

    this.state = {
      showModal: false,
      name: '',
      email: '',
      message: '',
      successVisible: false,
      errorVisible: false,
      error: {
        name: true,
        email: true,
        message: true,
      }
    }
  }

  handleSuccessDismiss() {
    this.setState({
      successVisible: false
    })
  }

  handleErrorDismiss() {
    this.setState({
      errorVisible: false
    })
  }

  clearForm() {
    this.setState({
      name: '',
      email: '',
      message: '',
      error: {
        name: true,
        email: true,
        message: true,
      }
    })
  }

  // componentWillMount() {
  //   this.setState({ showModal: false });
  // }

  close() {
    this.setState({ showModal: false });
  }

  closeAndSubmit() {
    this.setState({ showModal: false });
    let csrftoken = Cookies.get('csrftoken');
    fetch('/api/v1/contact/', {
      method: 'POST',
      headers: {
        // 'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        'X-CSRFToken': csrftoken
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        name: this.state.name,
        email: this.state.email,
        message: this.state.message
      })
    })
    .then(response => {
      if (response.ok) {
        this.setState({ successVisible: true })
        setTimeout(function() {
          this.setState({
            successVisible: false
          });
        }.bind(this), 5000);
        this.clearForm();
      } else {
        this.setState({ errorVisible: true })
        setTimeout(function() { this.setState({errorVisible: false}); }.bind(this), 5000);
      }
    })
    .catch(() => {
      this.setState({ errorVisible: true })
      setTimeout(function() { this.setState({errorVisible: false}); }.bind(this), 5000);
    })
  }

  open() {
    this.setState({ showModal: true });
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;

    let valid = false;
    if (target.name === 'email') {
      valid = validateEmail(target.value)
    } else {
      valid = target.value.length > 0
    }

    this.setState({
      ...this.state,
      [name]: target.value,
      error: {
        ...this.state.error,
        [name]: !valid,
      }
    });
  }

  

  render() {
    /*const popover = (
      <Popover id="modal-popover" title="popover">
        very popover. such engagement
      </Popover>
    );
    const tooltip = (
      <Tooltip id="modal-tooltip">
        wow.
      </Tooltip>
    );*/

    return (
      <div>
        <button
          onClick={this.open}>
          Contacte-nos
        </button>

        <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Contacte-nos</Modal.Title>
          </Modal.Header>
          <Modal.Body className="site__form">
            <InputFieldComponent name="name" value={this.state.name} onChange={this.handleInputChange} type="text" label="Nome" errorMessage="Este campo é obrigatório"/>
            <InputFieldComponent name="email" value={this.state.email} onChange={this.handleInputChange} type="email" label="Email" errorMessage="Introduza um endereço de e-mail válido"/>
            <InputFieldComponent name="message" value={this.state.message} onChange={this.handleInputChange} type="area" rows="10" label="Mensagem" errorMessage="Este campo é obrigatório"/>
          </Modal.Body>
          <Modal.Footer>
            <button onClick={this.closeAndSubmit} disabled={this.state.error.name || this.state.error.email || this.state.error.message}>Submeter</button>
            <p><small>Nota: Ao submeter esta mensagem, está a confirmar que tem mais de 13 anos de idade.</small></p>
          </Modal.Footer>
        </Modal>
        {this.state.successVisible &&
          <Alert bsStyle="success" onDismiss={this.handleSuccessDismiss}>
            <p>A sua mensagem foi enviada com sucesso.</p>
          </Alert>
        }
        {this.state.errorVisible &&
          <Alert bsStyle="danger" onDismiss={this.handleErrorDismiss}>
            <p>Ocorreu um erro, por favor tente novamente.</p>
          </Alert>
        }
      </div>
    );
  }
}

ContactFormComponent.displayName = 'ContactFormComponent';

// Uncomment properties you need
// ContactFormComponent.propTypes = {};
// ContactFormComponent.defaultProps = {};

export default ContactFormComponent;



// WEBPACK FOOTER //
// ./src/components/ContactFormComponent.js